export const getCategoryColor = (category: string) => {
  const colors: { [key: string]: string } = {
    entertainment: '#FF6B6B', // Coral Red (was lime green - too similar to home)
    gaming: '#FF8E53', // Orange (refined for better contrast)
    software: '#4A90E2', // Blue (kept - good distinct color)
    productivity: '#20B2AA', // Teal (kept - good distinct color)
    social: '#E91E63', // Pink (kept - good distinct color)
    health: '#4ECDC4', // Turquoise (was sky blue - too similar to software)
    education: '#FFA726', // Orange (refined - was too similar to gaming)
    finance: '#EF5350', // Red (refined - was tomato red, too similar to entertainment)
    shopping: '#AB47BC', // Purple (refined - was medium purple, too similar to other categories)
    food: '#FFB74D', // Amber (was gold - too bright and similar to education)
    home: '#66BB6A', // Green (refined - was light green, too similar to old entertainment)
    other: '#78909C', // Blue Grey (was silver - too light and similar to health)
  };
  return colors[category] || colors.other;
};

export const getCategoryIcon = (category: string) => {
  const icons: { [key: string]: string } = {
    entertainment: '🎬',
    gaming: '🎮',
    software: '💻',
    productivity: '📱',
    social: '📱',
    health: '🏥',
    education: '📚',
    finance: '💰',
    shopping: '🛒',
    food: '🍕',
    home: '🏠',
    other: '⚙️',
  };
  return icons[category] || icons.other;
};

export const CATEGORIES = [
  'entertainment',
  'gaming',
  'software',
  'productivity',
  'social',
  'health',
  'education',
  'finance',
  'shopping',
  'food',
  'home',
  'other',
] as const;

export type Category = typeof CATEGORIES[number]; 